export const PULSE_FIELD_LIMITS = {
    survey: {
        title: 100,
        description: 2500,
    },
    question: {
        text: 250,
    },
    answer: {
        text: 500,
        comment: 500,
    },
} as const;
